import { render, staticRenderFns } from "./MfaRecovery.vue?vue&type=template&id=8b34bdfe&scoped=true&"
import script from "./MfaRecovery.vue?vue&type=script&lang=js&"
export * from "./MfaRecovery.vue?vue&type=script&lang=js&"
import style0 from "./MfaRecovery.vue?vue&type=style&index=0&id=8b34bdfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b34bdfe",
  null
  
)

export default component.exports